import { FileExtensionType } from '~/enums/FileExtensionType';
import { FileMimeType } from '~/enums/FileMimeType';

const MIME_TYPE_TO_EXTENSION_GROUPING: Partial<
  Record<FileMimeType, FileExtensionType[]>
> = {
  [FileMimeType.Bmp]: [FileExtensionType.Bmp],
  [FileMimeType.Csv]: [FileExtensionType.Csv],
  [FileMimeType.Doc]: [FileExtensionType.Doc],
  [FileMimeType.Docm]: [FileExtensionType.Docm, FileExtensionType.Wopitest],
  [FileMimeType.Docx]: [FileExtensionType.Docx, FileExtensionType.Wopitestx],
  [FileMimeType.Gif]: [FileExtensionType.Gif],
  [FileMimeType.Heic]: [FileExtensionType.Heic],
  [FileMimeType.Html]: [FileExtensionType.Htm, FileExtensionType.Html],
  [FileMimeType.Jpeg]: [FileExtensionType.Jpeg, FileExtensionType.Jpg],
  [FileMimeType.Msg]: [FileExtensionType.Msg],
  [FileMimeType.Pdf]: [FileExtensionType.Pdf],
  [FileMimeType.Png]: [FileExtensionType.Png],
  [FileMimeType.Potx]: [FileExtensionType.Potx],
  [FileMimeType.Pptx]: [
    FileExtensionType.Pot,
    FileExtensionType.Pps,
    FileExtensionType.Ppt,
    FileExtensionType.Pptx,
  ],
  [FileMimeType.Pptm]: [FileExtensionType.Pptm],
  [FileMimeType.Rtf]: [FileExtensionType.Rtf],
  [FileMimeType.Tif]: [FileExtensionType.Tif],
  [FileMimeType.Tiff]: [FileExtensionType.Tiff],
  [FileMimeType.Txt]: [FileExtensionType.Txt],
  [FileMimeType.Webp]: [FileExtensionType.Webp],
  [FileMimeType.Wpd]: [FileExtensionType.Wpd],
  [FileMimeType.Xhtml]: [FileExtensionType.Xhtml],
  [FileMimeType.Xls]: [FileExtensionType.Xls],
  [FileMimeType.Xlsm]: [FileExtensionType.Xlsm],
  [FileMimeType.Xlsx]: [FileExtensionType.Xlsx],
  [FileMimeType.Xps]: [FileExtensionType.Xps],
};

/**
 * Given a list of file extensions, return an Object with the keys set to the MIME type and the values an array of file extensions
 * @param fileExtensions - List of file extensions
 * @returns Object with MIME type as keys and the values an array of file extensions as values
 */
export const fileTypesToMimeTypeGrouping = (
  fileExtensions: FileExtensionType[],
): Partial<Record<FileMimeType, FileExtensionType[]>> => {
  // given a list of file extensions, return the mime type and file extension tuple
  const mimeTypeGroups: Partial<Record<FileMimeType, FileExtensionType[]>> = {};
  Object.entries(MIME_TYPE_TO_EXTENSION_GROUPING).forEach(
    ([mimeType, extensions]) => {
      const filteredExtensions = extensions.filter((extension) =>
        fileExtensions.includes(extension),
      );
      if (filteredExtensions.length > 0) {
        mimeTypeGroups[mimeType as FileMimeType] = filteredExtensions;
      }
    },
  );

  return mimeTypeGroups;
};
